var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2917 0.791667C10.2917 0.354442 9.93724 0 9.5 0C9.06276 0 8.70833 0.354441 8.70833 0.791667V6.74281L6.11232 4.04295C5.80928 3.72779 5.30813 3.71796 4.99296 4.02101C4.67779 4.32405 4.66796 4.82521 4.97101 5.14038L8.92937 9.25704C9.0786 9.41228 9.28467 9.5 9.5 9.5C9.71533 9.5 9.92141 9.41228 10.0706 9.25704L14.029 5.14038C14.332 4.82521 14.3222 4.32405 14.007 4.02101C13.6919 3.71796 13.1908 3.72779 12.8877 4.04295L10.2917 6.74281V0.791667Z",
    fill: "#686868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58333 7.12516C1.58333 6.68793 1.22889 6.3335 0.791667 6.3335C0.354441 6.3335 0 6.68793 0 7.12516V11.8752C0 13.1869 1.06332 14.2502 2.375 14.2502H16.625C17.9367 14.2502 19 13.1869 19 11.8752V7.12516C19 6.68793 18.6456 6.3335 18.2083 6.3335C17.7711 6.3335 17.4167 6.68793 17.4167 7.12516V11.8752C17.4167 12.3124 17.0622 12.6668 16.625 12.6668H2.375C1.93778 12.6668 1.58333 12.3124 1.58333 11.8752V7.12516Z",
    fill: "#686868"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.09ecc74e.svg";
export { ForwardRef as ReactComponent };